import { createMuiTheme } from "@material-ui/core/styles";
import "typeface-source-code-pro";
import "./index.css";

export const DefaultTheme = createMuiTheme({
  typography: {
    fontFamily: "'Source Code Pro', monospace"
  },
  palette: {
    primary: {
      main: "#00f800"
    }
  }
});



// WEBPACK FOOTER //
// ./src/theme/MuiTheme.tsx